import gql from 'graphql-tag';

export const GET_CLIENT_PROVISION_RULE_LIST = gql`
  query getClientProvisionRuleList($input: ClientIdentifierInput!) {
    getClientProvisionRuleList(input: $input) {
      provisionRules {
        provisionRuleId
        name
        ruleEntityType
        ruleCondition
        items {
          itemId
          name
          sellingPrice {
            details {
              value
            }
          }
        }
        parentRule {
          provisionRuleId
          name
        }
        siteQuantities {
          site {
            id
            hq
          }
          quantity
        }
        defaultRule
      }
    }
  }
`;

export const GET_TEMPLATE_PROVISION_RULE_LIST = gql`
  query getProvisionRuleTemplateList($input: BillingTemplateIdentifierInput!) {
    getProvisionRuleTemplateList(input: $input) {
      provisionRules {
        provisionRuleId
        name
        ruleEntityType
        ruleCondition
        items {
          itemId
          name
          sellingPrice {
            details {
              value
            }
          }
        }
        parentRule {
          provisionRuleId
          name
        }
        siteQuantities {
          site {
            id
            hq
          }
          quantity
        }
        defaultRule
      }
    }
  }
`;

export const GET_PROVISION_RULE_CONDITION_META = gql`
  query getProvisionRuleConditionMeta(
    $input: GetProvisionRuleConditionMetaInput!
  ) {
    getProvisionRuleConditionMeta(input: $input)
  }
`;

export const GET_PROVISION_RULE = gql`
  query getProvisionRule(
    $input: ProvisionRuleIdentifierInput!
    $isClient: Boolean!
  ) {
    getProvisionRule(input: $input) {
      provisionRuleId
      name
      ruleEntityType
      ruleCondition
      items {
        itemId
        name
        description
        category {
          categoryId
          name
        }
        itemType
        sellingPrice {
          details {
            value
          }
        }
      }
      parentRule {
        provisionRuleId
      }
      siteQuantities @include(if: $isClient) {
        site {
          id
        }
        quantity
      }
      defaultRule
    }
  }
`;

export const GET_PROVISION_RULE_ITEMS = gql`
  query getProvisionRuleItems($input: ListInfoInput) {
    getProvisionRuleItems(input: $input) {
      provisionRuleItems {
        provisionRule {
          provisionRuleId
          name
          ruleEntityType
          ruleCondition
          parentRule {
            provisionRuleId
          }
          siteQuantities {
            site {
              id
              hq
            }
            quantity
          }
          defaultRule
        }
        serviceCatalogItem {
          name
          itemId
          sellingPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
          costPrice {
            model
            details {
              value
              afterHoursValue
            }
          }
        }
      }
    }
  }
`;

export const GET_UNPROVISIONED_INCLUDED_ITEMS = gql`
  query getUnProvisionedIncludedItems($input: ClientIdentifierInput!) {
    getUnProvisionedIncludedItems(input: $input) {
      itemId
      name
      sellingPrice {
        model
        details {
          value
        }
      }
    }
  }
`;

export const GET_TEMPLATE_UNPROVISIONED_INCLUDED_ITEMS = gql`
  query getUnProvisionedTemplateIncludedItems(
    $input: BillingTemplateIdentifierInput!
  ) {
    getUnProvisionedTemplateIncludedItems(input: $input) {
      itemId
      name
      sellingPrice {
        model
        details {
          value
        }
      }
    }
  }
`;

export const GET_APPLICABLE_PROVISION_RULE_LIST = gql`
  query getApplicableProvisionRuleList(
    $input: GetApplicableProvisionRuleInput!
  ) {
    getApplicableProvisionRuleList(input: $input) {
      serviceCatalogItem {
        itemId
      }
      provisionRuleList {
        provisionRuleId
        name
        ruleEntityType
        ruleCondition
        items {
          itemId
          name
        }
        parentRule {
          provisionRuleId
        }
        siteQuantities {
          site {
            id
            hq
          }
          quantity
        }
        defaultRule
      }
    }
  }
`;
